import React from 'react';
import getFieldTypeComponent from './getFieldTypeComponent';

const QualificationAttributeValueInput = ({
  value,
  attributeSlug,
  qualificationAttributes,
  onChange,
}) => {
  const selectedAttribute = qualificationAttributes?.find(({ slug }) => slug === attributeSlug);

  if (!selectedAttribute) {
    return null;
  }

  const FieldInput = getFieldTypeComponent(selectedAttribute.field_type);

  if (FieldInput) {
    return <FieldInput attribute={selectedAttribute} value={value} onChange={onChange} />;
  }

  return null;
};

export default QualificationAttributeValueInput;
